"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function NavigationIcon(props) {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "14", viewBox: "0 0 22 14" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: "#595050", d: "M13.46 0a.5.5 0 00-.18.05L.28 6.2a.5.5 0 00.02.92l4.65 1.92 1.92 4.64a.5.5 0 00.91.02l6.17-13a.5.5 0 00-.5-.7z" }) })));
}
exports.default = NavigationIcon;
